import {LabelHTMLAttributes} from 'react'
import {cn} from '@utilities/helpers'

export const Label = ({className, ...props}: LabelHTMLAttributes<HTMLLabelElement>) => (
    <label
        className={cn(
            'block text-neutral-700 text-sm font-medium overflow-hidden text-ellipsis whitespace-nowrap',
            className
        )}
        {...props}
    />
)

Label.displayName = 'Label'
